const { getOffsetTop } = window.BAO.Utils

class FixedBar extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    this.listeners.add(window, 'scroll', this.onScroll)
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.setVisibility()
  }

  setVisibility () {
    this.setAttribute('aria-hidden', !this.shouldBeVisible)

    // If FixedBar is visible, hide the FixedBarUpper
    const fixedBarUpper = document.querySelector('fixed-bar-upper')
    if (fixedBarUpper) {
      // Hide FixedBarUpper when FixedBar is visible, otherwise show it
      fixedBarUpper.setAttribute(
        'aria-hidden',
        this.shouldBeVisible ? 'true' : 'false',
      )
    }
  }

  get shouldBeVisible () {
    if (!this.externalEls?.form?.exists) return

    const formFooter = this.externalEls.form.element
    const pageFooter = this.externalEls.footer.element

    return (
      this.lastKnownY > getOffsetTop(formFooter) + formFooter.offsetHeight &&
      this.lastKnownY < getOffsetTop(pageFooter) - window.innerHeight
    )
  }
}

if (!customElements.get('fixed-bar')) {
  customElements.define('fixed-bar', FixedBar)
}
